import { PublicationItem } from 'components/discover/publications/model';
import { Keyword, PublicationCategory } from 'components/discover/publications/see-more/model';
import { useCategoryTree } from 'components/discover/publications/video-browser/hooks/use-category-tree';
import { useDefaultSelection } from 'components/discover/publications/video-browser/hooks/use-default-selection';
import { VideoBrowserPresentation } from 'components/discover/publications/video-browser/video-browser-presentation';

interface VideoBrowserProps {
  items: readonly PublicationItem[];
  categories: readonly PublicationCategory[];
  keywords: readonly Keyword[];
  onClose(): void;
}

const emptyArray: readonly [] = [];

export function VideoBrowser({ items = emptyArray, categories = emptyArray, keywords, onClose }: VideoBrowserProps) {
  const tree = useCategoryTree(categories, keywords, items);
  const defaultSelection = useDefaultSelection(items, categories);
  return <VideoBrowserPresentation tree={tree} defaultSelection={defaultSelection} onClose={onClose} />;
}
